/**
 * 文件说明:
 *
 * project layout
 *
 * ----------------------------------------
 * 创建用户: leo
 */

import {memo} from 'react'
import HzSubContent from '../sub-content'
import HzSiderMenu from '../sider-menu'
import {projectLayoutWrapContext} from './context'

const ProjectLayout = memo((props) => {
    const {PageComponent, authLayoutData = {}, children, pageProps} = props

    const {useSubContent = true, useSiderMenu = true} = authLayoutData?.hzLayoutOption ?? {}

    const {
        autoCrateComponent,
        SubContent = HzSubContent,
        SiderMenu = HzSiderMenu,
        useTitle,
    } = PageComponent?.hzLayoutOption ?? {}

    const projectLayoutWrapChildren = (
        <projectLayoutWrapContext.Provider
            value={{
                useTitle,
            }}
        >
            {children}
        </projectLayoutWrapContext.Provider>
    )

    if (autoCrateComponent) {
        return (
            <PageComponent
                SubContent={SubContent}
                SiderMenu={SiderMenu}
                pageProps={pageProps}
                authLayoutData={authLayoutData}
            >
                {projectLayoutWrapChildren}
            </PageComponent>
        )
    }

    if (!useSubContent) {
        return <PageComponent {...pageProps}>{projectLayoutWrapChildren}</PageComponent>
    }

    return (
        <SubContent SiderMenu={useSiderMenu && <SiderMenu />}>
            <PageComponent {...pageProps}>{projectLayoutWrapChildren}</PageComponent>
        </SubContent>
    )
})

export default ProjectLayout
